/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Image } from 'react-native'
import styles from './Styles/IconWithTextComponentStyle'
import { Container, Content, Text, List, ListItem, Icon, Item, Button } from "native-base";
import {
  SvgDonate,
  SvgKargoeCare,
  SvgProfileMenu,
  SvgTouchId,
  SvgDelivery,
  SvgPush,
  SvgHappening,
  SvgKargoelytics,
  SvgKargoelyticsRed,
  SvgCamera, SvgBackButton,
  SvgHome,
  SvgSetting,
  SvgMessages,
  SvgMessagesRed,
  SvgDocument,
  SvgExplora,
  SvgPeople,
  SvgMyShop,
  SvgDivider,
  SvgDonationEditPost,
  SvgEndorse,
  SvgLocationEditPost,
  SvgMyShopActive,
  SvgPeopleActive,
  SvgDonationEditPostActive,
  SvgEndorseActive,
  SvgLocationEditPostActive,

} from './SvgComponent'
import { Images } from '../Themes'

export default class IconWithTextComponent extends Component {

  checkSvgEditPost = (type, size, active) => {


    switch (type) {
      case 'People':
        return active ? <SvgPeopleActive size={size} /> : <SvgPeople size={size} />
      case 'My Shop':
        return active ? <SvgMyShopActive size={size} /> : <SvgMyShop size={size} />
      case 'Endorse':
        return active ? <SvgEndorseActive size={size} /> : <SvgEndorse size={size} />
      case 'Donation':
        return active ? <SvgDonationEditPostActive size={size} /> : <SvgDonationEditPost size={size} />
      case 'Location':
        return active ? <SvgLocationEditPostActive size={size} /> : <SvgLocationEditPost size={size} />
      case 'Music':
        return <Image style={{ width: size, height: size, tintColor: active ? 'rgb(133,208,207)' : null }} resizeMode="cover" source={Images.music} />
      default:
        return <SvgKargoelytics size={size} />
    }
  }
  checkType = (type, size, unreadMessages) => {



    switch (type) {
      case 'home':
        return <SvgHome size={size} />
      case 'camera':
        return <SvgCamera size={size} />
      case 'explora':
        return <SvgExplora size={size} />
      case 'messages':
        return unreadMessages?
                (<SvgMessagesRed size={size} />):
                (<SvgMessages size={size} />)
      case 'kargoelytics':
//        return <SvgKargoelyticsRed size={size} />
        return <SvgKargoelytics size={size} />
      case 'happening':
        return <SvgHappening size={size} />
      case 'profile':
        return <SvgProfileMenu size={size} />
      case 'settings':
        return <SvgSetting size={size} />

      default:
        return <SvgKargoelytics size={size} />
    }
  }
  render() {
    const { isSVG, isImage, textStyle, containerStyle, text, unreadMessages, svgSize = 30, active = false, isSVGEditPost} = this.props
    return (
      <View style={[styles.container, containerStyle]}>
        <Button

          vertical iconLeft transparent style={styles.button} onPress={() => this.props.onPress()}>
          {isSVG && this.checkType(this.props.type, svgSize, unreadMessages)}
          {isSVGEditPost && this.checkSvgEditPost(this.props.type, svgSize, active)}
          {isImage && <Image source={this.props.imageSource} />}

        </Button>

        {isSVG && <Text
          adjustsFontSizeToFit
          style={[styles.text, textStyle]}>{this.props.type}</Text>}
        {isSVGEditPost && <Text
          adjustsFontSizeToFit
          style={[styles.text, textStyle]}>{text}</Text>}
        {isImage && <Text
          adjustsFontSizeToFit
          style={[styles.text, textStyle]}>{text}</Text>}
      </View>
    )
  }
}
